import { render, staticRenderFns } from "./logentry.vue?vue&type=template&id=3132b8fe&scoped=true&"
import script from "./logentry.vue?vue&type=script&lang=js&"
export * from "./logentry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132b8fe",
  null
  
)

export default component.exports